import React from 'react';
import {connect} from 'react-redux';
import ContentTemplate from '../ContentTemplate';

const SelectedAmountText = ({formContext, frequency, amount_m, className, amounts}) => {
  const amountList = amounts || formContext.frequencies?.find(f => f.value === frequency)?.amounts;
  const theSelectedAmount = amountList?.find(a => a.amount_m === amount_m);

  if (theSelectedAmount?.contentType === 'template' && theSelectedAmount?.template) {
    return <ContentTemplate html={theSelectedAmount.template} formContext={formContext} contentKey={`amount:${frequency}:${amount_m}`} />;
  }

  if (theSelectedAmount?.message) {
    return <div className={className}>{theSelectedAmount.message}</div>;
  }

  return null;
};

const mapStateToProps = (state, ownProps) => {
  return {
    amount_m: state.form[`donate_data_${ownProps.amountField || 'amount_m'}`],
    frequency: ownProps.frequency || state.form.donate_data_frequency
  };
};

export default connect(mapStateToProps)(SelectedAmountText);
